import { createSlice } from "@reduxjs/toolkit";
import { checkDocumentStatusAPI } from "../../services/checkDocumentStatus";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const checkDocumentStatusSlice = createSlice({
  name: "checkDocumentStatus",
  initialState: data,
  reducers: {
    checkDocumentStatusInfo(state) {
      state.isLoading = true;
    },
    checkDocumentStatusInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    checkDocumentStatusInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    checkDocumentStatusInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const checkDocumentStatusHandler = (data) => async (dispatch) => {
  try {
    dispatch(checkDocumentStatusAction.checkDocumentStatusInfo());
    const response = await checkDocumentStatusAPI(data);
    dispatch(checkDocumentStatusAction.checkDocumentStatusInfoSuccess(response));
  } catch (e) {
    dispatch(checkDocumentStatusAction.checkDocumentStatusInfoFailure(e));
  }
};
export default checkDocumentStatusSlice.reducer;
export const checkDocumentStatusAction = checkDocumentStatusSlice.actions;
